import * as RSwitch from "@radix-ui/react-switch";
import type { ReactNode } from "react";

export interface SwitchProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  label: ReactNode;
  disabled?: boolean;
  className?: string;
  name?: string;
  id?: string;
}

export function Switch({
  checked,
  onCheckedChange,
  label,
  disabled,
  className,
  name,
  id,
}: SwitchProps): JSX.Element {
  return (
    <label className={className ?? "ds-switch"}>
      <RSwitch.Root
        className="ds-switch__root"
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        name={name}
        id={id}
      >
        <RSwitch.Thumb className="ds-switch__thumb" />
      </RSwitch.Root>
      <span className="ds-switch__label">{label}</span>
    </label>
  );
}
